import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
export default function CopyToClipboardButton(param) {
    var textToCopy = param.textToCopy;
    var _useState = _sliced_to_array(useState(false), 2), copied = _useState[0], setCopied = _useState[1];
    var handleCopy = function() {
        var _ref = _async_to_generator(function() {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(textToCopy)
                        ];
                    case 1:
                        _state.sent();
                        setCopied(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error("Copy failed:", err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCopy() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-[5px] items-center",
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: handleCopy,
                className: "w-[17px] h-[17px] flex-shrink-0",
                children: /*#__PURE__*/ _jsx("img", {
                    className: "w-full h-full",
                    src: "/images/icon-copy-btn-purple.png",
                    alt: ""
                })
            }),
            copied && /*#__PURE__*/ _jsx("span", {
                className: "fs-12 tc-15 text-nowrap",
                children: "คัดลอกแล้ว"
            })
        ]
    });
}
